import { palette } from '../../styles/tokens';

export type FleetTab = 'vehicles' | 'trips' | 'maintenance';

export const FLEET_TABS: { key: FleetTab; label: string }[] = [
  { key: 'vehicles', label: 'Vehicles' },
  { key: 'trips', label: 'Trips' },
  { key: 'maintenance', label: 'Maintenance' },
];

export const VEHICLE_STATUS: Record<string, { label: string; bg: string; fg: string }> = {
  available: { label: 'Available', bg: palette.greenWash, fg: palette.green },
  in_use: { label: 'In Use', bg: palette.blueWash, fg: palette.blue },
  maintenance: { label: 'Maintenance', bg: palette.amberWash, fg: palette.amber },
  retired: { label: 'Retired', bg: palette.g100, fg: palette.g400 },
};

export const TRIP_STATUS: Record<string, { label: string; bg: string; fg: string }> = {
  active: { label: 'Active', bg: palette.blueWash, fg: palette.blue },
  completed: { label: 'Completed', bg: palette.greenWash, fg: palette.green },
  cancelled: { label: 'Cancelled', bg: palette.g100, fg: palette.g400 },
};

export const MAINT_STATUS: Record<string, { label: string; bg: string; fg: string }> = {
  scheduled: { label: 'Scheduled', bg: palette.blueWash, fg: palette.blue },
  overdue: { label: 'Overdue', bg: palette.redWash, fg: palette.red },
  completed: { label: 'Completed', bg: palette.greenWash, fg: palette.green },
  cancelled: { label: 'Cancelled', bg: palette.g100, fg: palette.g400 },
};

export const MAINT_TYPES = [
  { value: 'scheduled', label: 'Scheduled' },
  { value: 'repair', label: 'Repair' },
  { value: 'inspection', label: 'Inspection' },
  { value: 'recall', label: 'Recall' },
  { value: 'other', label: 'Other' },
];

export const TH: React.CSSProperties = {
  fontSize: 11, fontWeight: 600, color: palette.g400, textTransform: 'uppercase',
  letterSpacing: '0.06em', padding: '10px 12px', textAlign: 'left',
  borderBottom: `1px solid ${palette.g150}`, whiteSpace: 'nowrap',
};

export const TD: React.CSSProperties = {
  fontSize: 13, color: palette.g700, padding: '10px 12px',
  borderBottom: `1px solid ${palette.g100}`, whiteSpace: 'nowrap',
};

export const LABEL: React.CSSProperties = {
  fontSize: 13, fontWeight: 500, color: palette.g500, marginBottom: 4, display: 'block',
};

export const INPUT: React.CSSProperties = {
  width: '100%', padding: '9px 12px', borderRadius: 8,
  border: `1px solid ${palette.g200}`, fontSize: 13.5, color: palette.g800,
  fontFamily: 'inherit', outline: 'none', boxSizing: 'border-box' as const,
};
